import affiliateHeroSrc from '@images/marketing/Affiliate-Hero.jpg';
import joinTheNomSquadHeroSrc from '@images/marketing/Careers-Hero.jpg';
import justTheFAQsHeroSrc from '@images/marketing/FAQ-Hero.jpg';
import treatThemRightHeroSrc from '@images/marketing/PLPs/Treats-Hero.jpg';
import pressHeroSrc from '@images/marketing/Press-Hero.jpg';
import teamMembersSectionHeroSrc from '@images/marketing/Team-Hero.jpg';
export var treatThemRightHeroSectionContent = {
    headline: 'Treat Them Right',
    subhead: "\n    The best dog (yours) deserves top-quality treats (ours). Use them for training sessions,\n    healthy snacks or as a way to reward that insanely adorable head tilt.\n  ",
    buttonLabel: 'Get Started',
    ctaUrl: '/profile',
    heroImage: {
        src: treatThemRightHeroSrc,
        alt: 'Packages of Nom Nom Sweet Potato Chews and Chicken & Cranberry Wafers',
        width: 552,
        height: 361,
    },
};
export var justTheFAQsHeroSectionContent = {
    headline: 'just the faq’s',
    heroImage: {
        src: justTheFAQsHeroSrc,
        alt: 'A dog parent grooming her dog with a cloth',
    },
};
export var plpAllExtrasHeroSectionContent = {
    headline: 'Our Healthy Extras',
    subhead: "\n    Nurturing your pup with gently cooked dog food is an essential way to add\n    delight to their day. So why stop there? We offer a number of products to\n    support their happiness and health.\n  ",
    buttonLabel: 'Get Started',
    ctaUrl: '/profile',
    heroImage: {
        width: 552,
        height: 361,
        src: treatThemRightHeroSrc,
        alt: 'Packages of Nom Nom Sweet Potato Chews and Chicken & Cranberry Wafers',
    },
};
export var teamMembersHeroSectionContent = {
    headline: 'Meet the Nom Squad',
    subhead: "\n    <p>We\u2019re a team of pet scholars, virtuosos, polyglots and plain old obsessives.\n      Everywhere from our kitchens to our research labs to our corporate HQ, you\u2019ll\n      find people working their tails off to create the best possible dog food,\n      supplements and nutritional support a dog could ever ask for.\n    </p>\n    <br/>\n    <p>Leashed up everywhere from Music City to the City of Brotherly Love, our\n      workforce backs our Nashville kitchens with fiercely loyal R&D, customer\n      experience and marketing support.\n    </p>",
    heroImage: {
        src: teamMembersSectionHeroSrc,
        alt: 'A dog laying on the kitchen floor is about to be fed a bowl of NomNom dog food.',
    },
};
export var joinTheNomSquadHeroSectionContent = {
    headline: 'Join the Nom Squad',
    subhead: "\n    Nom Nom is committed to saying bye to boring dog food AND boring jobs.\n    If you\u2019re ready for well-socialized teammates, open communication and work\n    that feels like play, say bye to boring and hi to Nom Nom.\n  ",
    heroImage: {
        src: joinTheNomSquadHeroSrc,
        alt: 'Two dogs laying on the floor are being fed some NomNom dog food.',
    },
};
export var affiliateHeroSectionContent = {
    headline: 'Become an affiliate',
    subhead: "\n    <p>If you have an audience of obsessed pup parents, we\u2019ll reward you for helping\n      them discover Nom Nom\u2019s vet-developed, floor-licking delicious dog food.\n    </p>\n    <br/>\n    <p>Sign up and start earning today.</p>\n  ",
    heroImage: {
        src: affiliateHeroSrc,
        alt: 'A woman hugs her Labrador Retriever',
    },
    ctaUrl: 'https://buy.nomnomnow.com/affiliate/',
    buttonLabel: 'Sign Up',
    isExternalLink: true,
};
export var pressHeroSectionContent = {
    headline: 'Who. What. Where. When. Why.',
    subhead: "\n    Nom Nom is driven by a dog-first devotion. We prioritize tastes and\n    textures to please the pickiest eaters. We champion variety to make\n    mealtime an adventure. We prepare recipes in our own Nashville kitchens.\n    And we work directly with vets so dogs get the nutrition they need,\n    customized to the individuals they are.\n  ",
    heroImage: {
        src: pressHeroSrc,
        alt: 'A black dog sitting beside a bowl of NomNom dog food.',
    },
    ctaUrl: 'mailto:press@nomnomnow.com',
    buttonLabel: 'Contact us at press@nomnomnow.com',
};
